module.exports = __webpack_public_path__ + "static/camera-1b32fb7e382c5eb82585e48ead5deff8.webp";